<template>
	<div class="agreement-step">
		<h3 class="step-title">{{ copy.title }}</h3>
		<p class="step-desc">
			{{ copy.descLead }}
			<a :href="serviceUrl" target="_blank">{{ copy.linkTerms }}</a>
			{{ copy.descMid }}
			<a :href="privacyUrl" target="_blank">{{ copy.linkPrivacy }}</a>
		</p>

		<button class="agree-btn" type="button" @click="$emit('agree')">{{ copy.agreeBtn }}</button>
	</div>
</template>

<script setup>
import { computed } from "vue";

defineEmits(["agree"]);

const props = defineProps({
	/** UI 語言：`zh-TW`（預設）| `en` */
	locale: {
		type: String,
		default: "zh-TW",
	},
});

const protocolLang = computed(() => (props.locale === "en" ? "en_us" : "zh_tw"));

const serviceUrl = computed(
	() => `/dist/protocol/website/service-agreement?lang=${protocolLang.value}`
);
const privacyUrl = computed(
	() => `/dist/protocol/website/privacy-policy-statement?lang=${protocolLang.value}`
);

const copy = computed(() =>
	props.locale === "en"
		? {
				title: "Agree to SeerQ terms and policies",
				descLead:
					"By tapping “I agree”, you confirm you are 18 or older and have read and accept the ",
				linkTerms: "SeerQ Terms of Service",
				descMid: " and ",
				linkPrivacy: "Privacy Policy",
				agreeBtn: "I agree",
			}
		: {
				title: "同意先知命局的條款和政策",
				descLead: "點按【我同意】即表示你已滿 18 歲且已閱讀並同意",
				linkTerms: "《先知命局的服務條款》",
				descMid: "及",
				linkPrivacy: "《隱私權益政策》",
				agreeBtn: "我同意",
			}
);
</script>

<style lang="scss" scoped>
.agreement-step {
	/* 压过全局/父级 break-all，英文按单词换行，不在词内拆开 */
	word-break: normal !important;
	overflow-wrap: break-word;
	word-wrap: break-word;
	hyphens: manual;

	.step-title {
		margin: 0 0 14px;
		font-size: 24px;
		font-weight: 700;
		line-height: 1.4;
		color: #333333;
		word-break: normal !important;
		overflow-wrap: break-word;
	}

	.step-desc {
		margin: 0;
		font-size: 16px;
		line-height: 1.7;
		color: #666666;
		word-break: normal !important;
		overflow-wrap: break-word;

		a {
			color: #4a7dff;
			text-decoration: none;
			word-break: normal !important;
		}
	}

	.agree-btn {
		width: 100%;
		height: 46px;
		margin-top: 28px;
		border: 0;
		border-radius: 10px;
		background: #111111;
		font-size: 18px;
		font-weight: 600;
		color: #ffffff;
		cursor: pointer;
	}
}
</style>
